"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.021 22.4h-.02a1.24 1.24 0 01-1.182-.99l-2.03-9.457H2.23c-.68 0-1.231-.565-1.231-1.261 0-.697.55-1.262 1.23-1.262h3.547c.578 0 1.078.412 1.202.99l1.125 5.241 3.14-12.71a1.237 1.237 0 011.172-.95 1.237 1.237 0 011.203.911l3.02 10.751 1.179-2.845a1.23 1.23 0 011.133-.768h3.619c.68 0 1.23.564 1.23 1.261s-.55 1.261-1.23 1.261h-2.805l-2.215 5.35c-.204.491-.687.8-1.207.766a1.238 1.238 0 01-1.108-.91L12.513 8.09l-3.3 13.357c-.138.56-.63.952-1.192.952z" }), "Analytics");
//# sourceMappingURL=Analytics.js.map